import React from "react";
import ManualPurchaseSection from "../../components/SubscriptionHistory/ManualPurchaseSection";

const ManualPurchase = () => {
  return (
    <div className="p-4 sm:p-6 w-full min-w-0 overflow-x-hidden bg-gray-50/60 min-h-[calc(100vh-4rem)]">
      <ManualPurchaseSection />
    </div>
  );
};

export default ManualPurchase;
